import React, { useEffect, ComponentProps } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Container, ContainerProps,
} from '@material-ui/core';

import auth from '../libs/auth';

interface Props extends Omit<ContainerProps, 'children'> {
  children: ComponentProps<any>['children']
}

const StudentLayout = (props: Props) => {
  const { children, ...containerProps } = props;
  const history = useHistory();
  const session = auth.getSession();

  const logout = () => {
    auth.logout();
    history.push('/student/login');
  };

  useEffect(() => {
    if (!auth.isStudent()) history.push('/');
  }, []);

  if(!session) return (<></>);

  return (
    <Container {...containerProps}>
      <div className="p-3 d-flex justify-content-between">
        <img src="/devleague_logo.png" height="75" alt="Logo"/>
        <div className="d-flex">
          <div className="d-flex flex-column justify-content-center align-items-end">
            <h4 className="m-0">{session.user.fullname} (#{session.user.userid})</h4>
            <p className="m-0">
              <small>{session.email}</small>
            </p>
          </div>
          <div className="pl-2 ml-2 d-flex align-items-center" style={{borderLeft: '1px solid gray'}}>
            <Button type="button"
                    onClick={logout}
                    variant="contained"
                    size="small"
                    color="primary">Logout</Button>
          </div>
        </div>
      </div>
      {children}
    </Container>
  );
};

export default StudentLayout;
